import Vue from 'vue'
import Vuex from 'vuex'
import Buyer from './buyer'
import Global from './global'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Global,
    Buyer
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js